import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getOrderById } from "../appState/slices/order/orderSlice";
import { OrderCard } from "../components";
import { Check } from "phosphor-react";
import { getColors } from "../appState/slices/color/colorSlice";

const SingleOrder = () => {
    const params = useParams();
    const { orderid } = params;
    const orderDetails = useSelector((state) => state.order.orderDetails);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(getOrderById(orderid));
        dispatch(getColors());
    }, [orderid])

    const exchangeorder = () => {

    };
    const returnorder = () => {
        navigate(`/return/${orderid}`);
    };

    const trackingSteps = [
        "Confirmed",
        "In Production",
        "Processing",
        "Ready",
        "Packed",
        "Shipped",
        "Delivered",
    ];

    const currentStep = trackingSteps.findIndex(
        (step) => step.toLowerCase() === orderDetails.status?.toLowerCase()
    );

    return (
        <div className="ordercontainer">
            <div className="row">

                <div className="col-lg-8 col-md-8 col-sm-12">
                    <div className="ordercard-container">

                        {orderDetails.products?.map((productDetails) => {
                            return (
                                <OrderCard productDetails={productDetails} />
                            );
                        })}
                        <div className="orderDetails">
                            <div className="order-subtotaldetails">
                                <div className="order-orderdetails">
                                    <div>
                                        Order value
                                    </div>
                                    <div>
                                        ₹ {orderDetails.subtotal}
                                    </div>
                                </div>
                                <div className="order-orderdetails">
                                    <div>
                                        Discount
                                    </div>
                                    <div>
                                        ₹ {orderDetails.couponDiscountValue || 0}
                                    </div>
                                </div>
                                <div className="order-orderdetails">
                                    <div>
                                        Delivery
                                    </div>
                                    <div>
                                        ₹ {orderDetails.deliveryCharges}
                                    </div>
                                </div>
                                <div className="order-totalvalue">
                                    <div>
                                        Total amount
                                    </div>
                                    <div>
                                        ₹ {orderDetails.totalAmount}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />

                <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="trackercontainer">
                        {trackingSteps.map((step, index) => {

                            const isCompleted = index < currentStep;

                            const isActive = index === currentStep;

                            const isUpcoming = index > currentStep;

                            return (
                                <React.Fragment key={step}>
                                    <div className="statuscontainer">

                                        <div
                                            className={`status-dot ${isCompleted
                                                    ? "completedstatus"
                                                    : isActive
                                                        ? "activestatus"
                                                        : "pendingstatus"
                                                }`}
                                        >
                                            {(isCompleted || isActive) && (
                                                <Check
                                                    size={12}
                                                    weight="bold"
                                                />
                                            )}
                                        </div>

                                        <div>
                                            <div
                                                className={`${isActive
                                                        ? "activetext"
                                                        : isCompleted
                                                            ? "completedtext"
                                                            : "pendingtext"
                                                    }`}
                                            >
                                                {step}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    marginTop: "2px",
                                                    color: "#999",
                                                }}
                                            >
                                                {isCompleted
                                                    ? "Completed"
                                                    : isActive
                                                        ? "Current Status"
                                                        : "Pending"}
                                            </div>
                                        </div>
                                    </div>

                                    {index !== trackingSteps.length - 1 && (
                                        <div className="tracking-vlcontainer">
                                            <div
                                                className={`tracking-vl ${index < currentStep
                                                        ? "completedline"
                                                        : ""
                                                    }`}
                                            />
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })}

                        {orderDetails.status === "Cancelled" && (
                            <div
                                style={{
                                    marginTop: "20px",
                                    color: "#ff4d4f",
                                    fontWeight: 600,
                                }}
                            >
                                Order Cancelled
                            </div>
                        )}
                    </div>
                    {/* <div className="returnbutton-container">
                        <div className="exchangebutton" onClick={exchangeorder}>
                            Exchange
                        </div>
                        <div className="returnbutton" onClick={returnorder}>
                            Return
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default SingleOrder;
